import http from "~/assets/scripts/utils/http";

interface IAxiosRequest {
    method: 'post' | 'get',
    url: string,
    data?: Object,
    loadingOptions?: IRequestLoadingOption,
    params?: Record<string, NString | number | boolean>
}

async function request<T>(param: IAxiosRequest): Promise<T> {
    var url = param.url;
    var func: Function;
    var data: any;
    if (param.method == "get") {
        func = http.$get;
        data = param.params;
    }
    else {
        func = http.$post;
        if (param.params) url = http.objToUrl(url, param.params);
        data = param.data
    }
    var loadingObj = param.loadingOptions;

    if (loadingObj && Object.hasOwn(loadingObj, "loading"))
        loadingObj.loading = (Number(loadingObj.loading) || 0) + 1
    else loadingObj = undefined;

    try {
        var rlt = await func(url, data, null);
        return <T>rlt;
    } finally {
        if (loadingObj && loadingObj.loading) {
            loadingObj.loading--;
            if (loadingObj.loading < 0) loadingObj.loading = 0;
        }
    }
}

export default request;